const Routes = {
  STOP_PLACE: "stop_place",
  GROUP_OF_STOP_PLACE: "group",
  REPORTS: "reports",
  CHANGELOG: "changelog",
};

export default Routes;
